import script from "./EmailVerificationPending.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailVerificationPending.vue?vue&type=script&setup=true&lang=js"

import "./EmailVerificationPending.vue?vue&type=style&index=0&id=4b7ff6f4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b7ff6f4"]])

export default __exports__